module.exports = __webpack_public_path__ + "img/slider_inicio.4cbcc428.jpeg";